module.exports = __webpack_public_path__ + "img/browse-gnome.cdef8996.png";